<template>
  <div class="message">
    <div class="wrap" v-if="!defaut">
        <div class="tab">
        <div class="item" :class="active==1?'active':''" @click="tabselect(1)">
          <span>活动公告</span>
        </div>
        <div class="item" :class="active==2?'active':''" @click="tabselect(2)">
          <span>系统通知</span>
        </div>
    </div>
      <div class="content">
        <div class="nonum" v-if='list.length==0'>
          <img src="../assets/img/nonum@2x.png" alt="">
          <p>暂无数据</p>
        </div>
        <div class="item" v-for='item in list' :key='item.id' @click="lookdefaut(item)">
          <div class="titlecontent">
            <span class="titlefont">{{item.noticeTitle}}</span>
            <span class="timefont">{{item.noticeBeginTime|formatDate}}</span>
          </div>
            <div class="contentfont over_more">{{item.noticeContent}}</div>
        </div>
        </div>
    </div>
    <div class="defautwrap" v-if='defaut'>
       <div class="topnav">
        <img src="../assets/img/fh-icon@2x.png" alt="" @click="defaut=false">
        活动公告
      </div>
      <div class="messageblock">
        <p class="defautTitle">{{title}}</p>
        <p class="defautContent">{{content}}</p>
      </div>
    </div>
  </div>
</template>

<script>

import {getmessge} from '@/api/message'
// @ is an alias to /src
export default {
  data(){
    return{
      active:1,
      form:{
        productId:'',
        channelId:'',
        userId:'',
      },
        alllist:[],
        defaut:false,
        content:'',
        title:''
    }
  },
  computed:{
    list:function () {
      var arr = this.alllist.filter(item => {return item.noticeType == this.active})
      return arr
    }
  },
  filters:{
    formatDate(data) {
        if(!data){return '-'}
        //时间戳是整数，否则要parseInt转换
        var time = new Date(data*1000); // 需要使用Date格式进行日期转化，若是时间戳、字符串时间，需要通过new Date(..)转化
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return isZero(m)+'-'+isZero(d)+' '+isZero(h)+':'+isZero(mm);
        // return y+'-'+isZero(m)+'-'+isZero(d);
        function isZero(m){
        return m<10?'0'+m:m
        }
    }
  },
  created(){
    if(this.$route.query.osType){
      this.form.osType = this.$route.query.osType
      this.form.channelId = this.$route.query.channelId
      this.form.productId = this.$route.query.productId
      this.form.userId = this.$route.query.userId
     }
    getmessge(this.form).then(res=>{
      if(res.data.code == 200){
        var arr = []
        res.data.data.forEach((element,index) => {
          if(element.noticeUp==1){
            arr.unshift(element)
          }else{
            arr.push(element)
          }
        });
         this.$set(this,'alllist',arr)
      }
    })
  },
  methods:{
    lookdefaut(content){
      this.title = content.noticeTitle
      this.content = content.noticeContent
      this.defaut = true
    },
    tabselect(num){
      this.active = num
    }
  }
}
</script>
<style lang="less">
  .message{
    font-size: 0.7rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .tab{
    height: 2.25rem;
    width: 100%;
    font-size: 0.7rem;
    line-height: 2.25rem;
    background: #fff;
    border-bottom: 0.28rem solid #F7F8F9;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .item{
      width: 50%;
      float: left;
      text-align: center;
      color: #666666;
    }
      .item.active{
        color: #111111;
        span{
          position: relative;
          &::after{
          content: '';
          width: 100%;
          height: 0.2rem;
          background: #F1B82E;
          position: absolute;
          left: 0;
          right: 0;
          top: 1.07rem;
          margin: auto;
          border-radius: 0.1rem 0.1rem 0 0;
          z-index: 10;
          }
        }
      }
    }
    .content{
      width: 100%;
      height: 100%;
      background: #fff;
      padding:2.25rem 0.5rem 0;
      overflow-y: auto;
      position: relative;
      .grayblock{
        height: 0.28rem;
        background: #F7F8F9;
      }
      .item{
        width: 100%;
        height: 3.8rem;
        border-bottom: 1px solid #D2D2D2;
        padding: 0.9rem 0;
        .titlecontent{
          display: flex;
          align-items: center;
          .titlefont{
            flex: 1;
          }
          .timefont{
            color: #999999;
            margin-right: 0;
            font-size: 0.5rem;
          }
        }
      }
      .contentfont{
        font-size: 0.65rem;
        color: #999999;
        margin-top: 0.57rem;
        background: url(../assets/img/icon@2x.png) no-repeat right center;
        background-size: 0.63rem auto;
        padding-right: 0.63rem;
        overflow: hidden;
        
      }
    }
    .defautwrap{
      width: 100%;
      height: 100%;
      background: #F7F8F9;
    .topnav{
        width: 100%;
        height: 2.25rem;
        background:#fff;
        text-align: center;
        line-height: 2.25rem;
        font-size:0.8rem;
        font-family:PingFang SC;
        color:rgba(17,17,17,1);
        position: relative;
        // border-bottom: 0.28rem solid #F7F8F9;
        img{
          height: 0.75rem;
          display: block;
          position: absolute;
          left: 0.75rem;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .messageblock{
        position: absolute;
        top: 2.53rem;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        overflow-y: auto;
        padding: 0.75rem 0.5rem;
      }
      .defautTitle{
        font-size: 0.9rem;
        font-weight: bold;
        color: #000;
      }
      .defautContent{
        color: #999999;
        font-size: 0.7rem;
        margin-top: 0.67rem;
      }
    }
  } 
</style>